// extracted by mini-css-extract-plugin
export default {"aglmd-icon":"FNqKIJ5g8AJJ6eTf9XFT","aglmd-icon--fw":"Nn7bbwCoboacNsPDqeyy"};